<template>
  <div>
    <!-- <div class="Products">
    <div class="hero simple" style="background-image: url('/static/leeno/markets_first_bg.jpg')">
      <div class="content">
        <h1 class="hero-title">{{ $t('messages.markets') }}</h1>
      </div>
    </div> -->
    <div class="menu_bg">
    </div>
    <div class="product-container">
      <div class="content">
        <h1 class="hero-title">{{ $t('messages.markets') }}</h1>
      </div>
    </div>
    <div class="container">
      <div class="items-wrap">
        <div class="item market-wide">
          <!-- 消费性电子 -->
          <div class="image-wrap">
            <img src="https://mp-a6096c8d-ce7a-456e-969a-9f1913d486a1.cdn.bspapp.com/Resource/home/1731548428785_0.jpg"
              alt="">
          </div>
          <div class="content">
            <h2>{{ $t('messages.titleConsumerElectronics') }}</h2>
            <p class="text">{{ $t('messages.introConsumerElectronics') }}</p>
            <!-- <a  class="primary-btn market-btn" title="READ MORE">{{ $t('messages.titleReadMore') }}</a> -->
          </div>
        </div>
        <div class="item market-wide">
          <!-- 测试领域 -->
          <div class="image-wrap">
            <img src="https://mp-a6096c8d-ce7a-456e-969a-9f1913d486a1.cdn.bspapp.com/Resource/home/1731548453949_0.jpg"
              alt="">
          </div>
          <div class="content">
            <h2>{{ $t('messages.titleTesting') }}</h2>
            <p class="text">{{ $t('messages.introTestingP1') }}</p>
            <p class="text">{{ $t('messages.introTestingP2') }}</p>
            <p class="text">{{ $t('messages.introTestingP3') }}</p>
            <p class="text">{{ $t('messages.introTestingP4') }}</p>
            <!-- <a  class="primary-btn market-btn" title="READ MORE">{{ $t('messages.titleReadMore') }}</a> -->
          </div>
        </div>
        <div class="item market-wide">
          <!-- 工业领域 -->
          <div class="image-wrap">
            <img src="https://mp-a6096c8d-ce7a-456e-969a-9f1913d486a1.cdn.bspapp.com/Resource/home/1731548461885_0.jpg"
              alt="">
          </div>
          <div class="content">
            <h2>{{ $t('messages.titleIndustrial') }}</h2>
            <p class="text">{{ $t('messages.introIndustrial') }}</p>
            <!-- <a  class="primary-btn market-btn" title="READ MORE">{{ $t('messages.titleReadMore') }}</a> -->
          </div>
        </div>
        <div class="item market-wide">
          <!-- 新能源 -->
          <div class="image-wrap">
            <img src="https://mp-a6096c8d-ce7a-456e-969a-9f1913d486a1.cdn.bspapp.com/Resource/home/1731548466403_0.jpg"
              alt="">
          </div>
          <div class="content">
            <h2>{{ $t('messages.titleNewEnergy') }}</h2>
            <p class="text">{{ $t('messages.introNewEnergy') }}</p>
            <!-- <a  class="primary-btn market-btn" title="READ MORE">{{ $t('messages.titleReadMore') }}</a> -->
          </div>
        </div>
        <div class="item market-wide">
          <!-- 医疗领域 -->
          <div class="image-wrap">
            <img src="https://mp-a6096c8d-ce7a-456e-969a-9f1913d486a1.cdn.bspapp.com/Resource/home/1731548470652_0.jpg"
              alt="">
          </div>
          <div class="content">
            <h2>{{ $t('messages.titleMedical') }}</h2>
            <p class="text">{{ $t('messages.introMedical') }}</p>
            <!-- <a  class="primary-btn market-btn" title="READ MORE">{{ $t('messages.titleReadMore') }}</a> -->
          </div>
        </div>
        <div class="item market-wide">
          <!-- 通信领域 -->
          <div class="image-wrap">
            <img src="https://mp-a6096c8d-ce7a-456e-969a-9f1913d486a1.cdn.bspapp.com/Resource/home/1731548474992_0.jpg"
              alt="">
          </div>
          <div class="content">
            <h2>{{ $t('messages.titleComunication') }}</h2>
            <p class="text">{{ $t('messages.introComunicationP1') }}</p>
            <p class="text">{{ $t('messages.introComunicationP2') }}</p>
            <p class="text">{{ $t('messages.introComunicationP3') }}</p>
            <!-- <a  class="primary-btn market-btn" title="READ MORE">{{ $t('messages.titleReadMore') }}</a> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CategoryMenu from "@/components/CategoryMenu.vue";
export default {
  components: {
    CategoryMenu
  }
};
</script>

<style scoped>
.menu_bg {
  height: 100px;
  width: 100%;
  position: relative;
  background-size: cover;
  background-color: #00579C;
}

.product-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
}

.product-container .content {

  width: 100%;
  left: 0;
  background: rgba(0, 0, 0, 0) linear-gradient(90deg,
      var(--unnamed-color-008682) 0%,
      rgba(255, 255, 255, 0) 100%) 0% 0% no-repeat padding-box;
  background: rgba(0, 0, 0, 0) linear-gradient(90deg, #0077b4 0%, rgba(255, 255, 255, 0) 100%) 0% 0% no-repeat padding-box;
  padding: 24px 0 18px 73px;
}

.content .hero-title {
  margin: 0;
  padding: 0;
  color: #fff;
  font-size: 46px;
}


.hero.simple {
  height: 475px;
  width: 100%;
  position: relative;
  background-size: cover;
}

.hero.simple:after {
  z-index: 1;
  content: "";
  background: rgba(0, 0, 0, 0) linear-gradient(180deg, #000000 0%, rgba(255, 255, 255, 0) 100%) 0% 0% no-repeat padding-box;
  width: 100%;
  height: 100%;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0.5;
}

@media (max-width: 1539px) {
  .hero.simple .content {
    padding: 24px 0 18px 48px;
  }
}

.hero.simple .content {
  position: absolute;
  bottom: 0;
  width: 100%;
  left: 0;
  background: rgba(0, 0, 0, 0) linear-gradient(90deg,
      var(--unnamed-color-008682) 0%,
      rgba(255, 255, 255, 0) 100%) 0% 0% no-repeat padding-box;
  background: rgba(0, 0, 0, 0) linear-gradient(90deg, #0077b4 0%, rgba(255, 255, 255, 0) 100%) 0% 0% no-repeat padding-box;
  padding: 24px 0 18px 73px;
}

.hero.simple .hero-title {
  margin: 0;
  padding: 0;
  color: #fff;
  font-size: 46px;
}

.container {
  padding: 47px 74px 72px;
}



.items-wrap {
  display: flex;
  flex-direction: column;
  gap: 35px;
}

@media (max-width: 1539px) {
  .items-wrap .item.market-wide {
    gap: 120px;
  }
}

@media (max-width: 1919px) {
  .items-wrap .item.market-wide {
    gap: 103px;
  }
}

.items-wrap .item.market-wide {
  max-width: 100%;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, .1607843137);
  border-radius: 10px;
  background-color: #fafafa;
  height: 378px;
  padding: 38px 70px;
  display: flex;
  justify-content: space-between;
  gap: 148px;
}

.items-wrap .item.market-wide .content {
  flex: 1;
}

.items-wrap .item.market-wide .content h2 {
  color: #0077b4;
  font-size: 37px;
  line-height: 56px;
  font-weight: 600;
  margin: 0 0 12px;
}

.items-wrap .item.market-wide .content p {
  color: #6f6f6f;
  font-size: 20px;
  line-height: 28px;
  overflow: hidden;
  -webkit-line-clamp: 5;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  margin: 0 0 24px;
}

.items-wrap .item.market-wide .content a.market-btn {
  max-width: -moz-max-content;
  max-width: max-content;
  margin: 0;
  padding: 15px 35px;
  height: 57px;
  font-size: 19px;
  text-align: center;
}

.primary-btn {
  background-color: #0077b4;
  color: #fff !important;
  padding: 12px 35px 15px 35px;
  text-decoration: none;
  box-shadow: -4px 4px 5px rgba(0, 0, 0, .2196078431);
  border-radius: 5px;
  border: none;
  margin: 0;
  cursor: pointer;
  font-size: 19px;
  height: 50px;
  letter-spacing: 1.69px;
  transition: background-color .2s ease-in-out;
}

@media (max-width: 1539px) {
  .items-wrap .item.market-wide .image-wrap {
    flex: 0 1 459px;
  }
}

@media (max-width: 1539px) {
  .items-wrap .item.market-wide .image-wrap img {
    height: 277px;
  }
}

.items-wrap .item.market-wide .image-wrap img {
  width: 518px;
  height: 292px;
  border-radius: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/firstLevel/Markets.vue